'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  var accountPath = [action.feis_id, 'accounts', action.acct_id];

  switch (action.type) {
    case 'UPDATE_CART_START':
      return action.show_loading ? state.setIn(accountPath, (0, _immutable.fromJS)({ loading: true })) : state;

    case 'UPDATE_CART':
      var updatedCart = action.payload;
      updatedCart.paid = updatedCart.credits.total > 0; // Add 'paid' flag to cart
      return state.setIn(accountPath, (0, _immutable.fromJS)(updatedCart));

    case 'UPDATE_BALANCE':
      return state.setIn([].concat(accountPath, ['balance']), action.payload.balance);

    case 'GET_REGISTERED_DATA_FOR_PERSON':
      return action.payload.reduce(function (state, a) {
        return state.updateIn([action.feis_id, 'accounts', a.accountId], function () {
          var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.fromJS)({});
          return (0, _immutable.fromJS)(_extends({}, data.toJS(), { balance: a.balance, paidFeisFee: a.paidFeisFee, numParticipants: a.numParticipants }));
        });
      }, state);

    case 'GET_UNPAID_ACCOUNTS_FOR_FEIS':
      return action.payload.reduce(function (state, a) {
        return state.setIn([action.feis_id, 'accounts', a.id, 'paid'], false);
      }, state);

    case 'SET_CURRENT_DEREGISTERING_FLAG':
      return state.setIn([action.feis_id, 'currentDeregisteringFlag'], action.isDeregistering);

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/feiseanna/cart/index.js
// module id = 694
// module chunks = 0